function SkeletonBlock({ width, height, borderRadius, style }) {
  return (
    <div
      className="skeleton-block"
      style={{ width, height, borderRadius, ...style }}
    />
  )
}

function SkeletonLine({ width = '100%', height = '0.75rem' }) {
  return <SkeletonBlock width={width} height={height} borderRadius="4px" />
}

export function DashboardSkeleton() {
  return (
    <div className="page dashboard skeleton-container">
      {/* Medication week strip */}
      <div className="skeleton-med-week">
        <SkeletonLine width="5rem" height="0.8rem" />
        <div className="skeleton-med-strip">
          {Array.from({ length: 7 }, (_, i) => (
            <div key={i} className="skeleton-med-cell">
              <SkeletonBlock width="100%" height="100%" borderRadius="6px" />
            </div>
          ))}
        </div>
      </div>

      {/* Today's classes section */}
      <div className="skeleton-section">
        <SkeletonLine width="10rem" height="1rem" />
        <div className="skeleton-list">
          {Array.from({ length: 3 }, (_, i) => (
            <div key={i} className="skeleton-dashboard-item">
              <SkeletonLine width="4.5rem" />
              <SkeletonLine width="60%" />
            </div>
          ))}
        </div>
      </div>

      {/* Schedule section */}
      <div className="skeleton-section">
        <SkeletonLine width="8rem" height="1rem" />
        <div className="skeleton-list">
          {Array.from({ length: 5 }, (_, i) => (
            <div key={i} className="skeleton-schedule-item">
              <SkeletonBlock width="4.5rem" height="0.75rem" borderRadius="4px" />
              <SkeletonBlock width="20px" height="20px" borderRadius="4px" />
              <SkeletonLine width="50%" />
            </div>
          ))}
        </div>
      </div>

      {/* Task section */}
      <div className="skeleton-section">
        <SkeletonLine width="6rem" height="1rem" />
        <div className="skeleton-list">
          {Array.from({ length: 3 }, (_, i) => (
            <div key={i} className="skeleton-dashboard-item">
              <SkeletonBlock width="8px" height="8px" borderRadius="50%" />
              <SkeletonLine width="55%" />
              <SkeletonLine width="3rem" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export function ScheduleSkeleton({ count = 6 }) {
  return (
    <div className="skeleton-container">
      <div className="skeleton-list skeleton-list--bordered">
        {Array.from({ length: count }, (_, i) => (
          <div key={i} className="skeleton-schedule-item">
            <SkeletonBlock width="4.5rem" height="0.75rem" borderRadius="4px" />
            <SkeletonBlock width="20px" height="20px" borderRadius="4px" />
            <SkeletonLine width={i % 2 === 0 ? '45%' : '60%'} />
          </div>
        ))}
      </div>
    </div>
  )
}
